// What a book can be made as in a print builder: a PDF of the pages to print anywhere, or a bound book.
import { FORMATS } from '../../../shared/print'

// The pages as on screen, for printing anywhere.
export const SCREEN = { trim: { width: 8, height: 10 }, minPages: 0, bound: false }
export const FINISHES = [
  { id: 'pdf', label: 'PDF', hint: '8 × 10 in, to print anywhere' },
  ...FORMATS.map((x) => ({
    id: x.id,
    label: x.binding === 'hardcover' ? 'Hardcover' : 'Paperback',
    hint: x.label.split(', ')[1]!,
  })),
]
